module.exports = __webpack_public_path__ + "static/media/transactionFilter.8cefc8b6.svg";